module.exports = __webpack_public_path__ + "static/media/RecomendaGramado.5f8ee0cc.jpg";